<template>
  <div class="content">
    <div class="top">
      <img src="../../assets/images/news.png" />
      <span>暂无最新消息</span>
    </div>
    <div class="middn">
      <div class="top">
        <span>用户统计</span>
      </div>
      <div class="seach">
        <el-form :inline="true">
          <el-form-item label="统计年份">
            <el-date-picker
              :picker-options="pickerOptions"
              v-model="searchForm.year"
              type="year"
              placeholder="选择年"
              @change="handleYearChange"
              format="yyyy 年"
              value-format="yyyy"
              :editable="false"
            />
          </el-form-item>
          <el-form-item label="统计月份">
            <el-date-picker
              :picker-options="pickerMonth"
              v-model="searchForm.month"
              type="month"
              placeholder="选择月"
              @change="handleMonthChange"
              format="MM 月"
              value-format="M"
              popper-class="myMonth"
              :disabled="!searchForm.year"
              :editable="false"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="cumulative">
        <img src="../../assets/images/leiji.png" alt />
        <div class="icon" v-loading="loading" element-loading-text="数据加载中">
          <div class="left">
            <img src="../../assets/images/wd.png" alt />
            <div class="text">
              <span>{{ list.cou }}</span>
              <p>实名注册企业（未去重）</p>
            </div>
          </div>
          <div class="right">
            <img src="../../assets/images/yd.png" alt />
            <div class="text">
              <span>{{ list.discou }}</span>
              <p>实名注册企业（已去重）</p>
            </div>
          </div>
          <div class="right">
            <img src="../../assets/images/wd.png" alt />
            <div class="text">
              <span>{{ list.notRealNameCount }}</span>
              <p>未实名注册企业</p>
            </div>
          </div>
        </div>
      </div>
      <div class="platform">
        <img src="../../assets/images/quxian.png" alt />
        <div
          style="
            margin-top: 20px;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
          "
        >
          <el-table :data="tableData" v-loading="loading" element-loading-text="数据加载中">
            <el-table-column prop="platName" label="平台"></el-table-column>
            <el-table-column prop="cou" label="实名注册企业（未去重）"></el-table-column>
            <el-table-column prop="discou" label="实名注册企业（已去重）"></el-table-column>
            <el-table-column prop="notRealNameCount" label="未实名注册企业"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { erTotalByParam } from "@/api/statistics";
import { list } from "../../api/myCenter";
export default {
  data() {
    return {
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() < Date.now() // 选当前时间之后的时间
          return time.getTime() > Date.now(); // 选当前时间之前的时间
        }
      },
      pickerMonth: {
        disabledDate: time => {
          let year = this.searchForm.year;
          let date = new Date().getFullYear();
          if (date > year) {
            return time.getTime() < Date.now();
          } else if (date == year) {
            return time.getTime() > Date.now();
          }
        }
      },
      searchForm: {
        year: "",
        month: ""
      },
      tableData: [],
      list: {}
    };
  },
  created() {
    this.geterTotalByParam();
  },
  methods: {
    geterTotalByParam() {
      this.loading = true;
      erTotalByParam(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res);
        console.log(res, "rrreee");
        if (res.code == 200) {
          this.tableData = res.data.resultList;
          this.list = res.data.resultCount;
          this.loading = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleYearChange() {
      this.geterTotalByParam();
    },
    handleMonthChange() {
      this.geterTotalByParam();
    }
  }
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  height: 848px;
  border-radius: 8px;
  .top {
    font-size: 14px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2a2a2a;
    line-height: 40px;
    height: 40px;
    background-color: #fff;
    padding-left: 10px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    img {
      margin-right: 10px;
      margin-top: 5px;
    }
  }
  .middn {
    margin-top: 20px;
    height: 845px;
    background-color: #fff;
    padding: 0;
    border-radius: 8px;
    .top {
      height: 66px;
      line-height: 66px;
      border-bottom: 1px solid #f3f4f9;
      span {
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2981ee;
        border-left: 8px solid #2981ee;
        padding-left: 12px;
      }
    }
    .seach {
      margin-top: 20px;
      margin: 20px;
    }
    .cumulative {
      width: 100%;
      display: flex;
      flex-direction: column;
      img {
        margin: 0 auto;
      }
      .icon {
        margin-top: 20px;
        height: 80px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        .left {
          margin-right: 15px;
          display: flex;
          img {
            margin-top: 8px;
            height: 60px;
            width: 60px;
          }
          .text {
            margin-left: 5px;
            span {
              font-size: 26px;
              font-family: Alibaba PuHuiTi;
              font-weight: 500;
              color: #2a2a2a;
            }
            p {
              margin-left: 5px;
              font-size: 16px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #2a2a2a;
            }
          }
        }
        .right {
          margin-left: 25px;
          display: flex;
          img {
            margin-top: 8px;
            width: 60px;
            height: 60px;
          }
          .text {
            margin-left: 5px;
            span {
              font-size: 26px;
              font-family: Alibaba PuHuiTi;
              font-weight: 500;
              color: #2a2a2a;
            }
            p {
              font-size: 16px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #2a2a2a;
            }
          }
        }
      }
    }
    .platform {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      img {
        width: 378px;
        height: 37px;
      }
      /deep/.el-table thead tr th {
        background: #f3f4f9;
      }
      /deep/ .el-table th > .cell {
        padding-left: 15px;
      }
      /deep/ .el-table td > .cell {
        padding-left: 25px;
      }
    }
  }
}
</style> 

<style lang="less">
</style>